import {
  Box,
  Tooltip,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  CircleCheckIcon,
  AlertIcon,
  AlertCriticalIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import { palette } from '@fortress-technology-solutions/fortress-component-library/design';
import React from 'react';

type CardStatus = 'pass' | 'fail' | 'warning';

type Props = {
  label: string,
  part: Object,
  tooltip: string,
  selected: boolean,
  onClick: () => void,
  displayStatus: boolean,
  complianceStatus: Object,
};

const StatusCard = ({
  label,
  part,
  tooltip,
  selected,
  onClick,
  displayStatus,
  complianceStatus,
}: Props) => {
  const IconStatus = ({
    status,
    display,
  }: {
    status: CardStatus,
    display: boolean,
  }) => {
    let Icon = null;
    let backgroundColor = null;

    if (display) {
      if (status === 'pass') {
        Icon = <CircleCheckIcon color="success" />;
        backgroundColor = palette.lighter.green;
      } else if (status === 'warning') {
        Icon = <AlertCriticalIcon color="warning" />;
        backgroundColor = palette.lighter.warning;
      } else {
        Icon = <AlertIcon color="error" />;
        backgroundColor = palette.lighter.red;
      }
    }

    return (
      <Box
        sx={{
          alignItems: 'center',
          borderRadius: '50%',
          backgroundColor,
          display: 'flex',
          height: '32px',
          justifyContent: 'center',
          marginBottom: '8px',
          width: '32px',
        }}
      >
        {Icon}
      </Box>
    );
  };

  return (
    <Tooltip
      title={tooltip}
      placement="bottom"
      arrow
      containerSX={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          border: '1px solid',
          borderColor: selected ? palette.dark.grey : palette.lighter.grey,
          borderRadius: '4px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          marginRight: '8px',
          minWidth: '175px',
          padding: '16px',
        }}
        onClick={onClick}
      >
        <Box>
          <IconStatus status={complianceStatus} display={displayStatus} />
          <Typography
            variant="titleSmall"
            color={selected ? palette.dark.grey : palette.main.grey}
          >
            {label}
          </Typography>
        </Box>

        <Typography
          variant="bodyMedium"
          color={selected ? palette.dark.grey : palette.main.grey}
        >
          {part}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default StatusCard;
